import FilterResolveDresonRule from "./FilterResolveDresonRule";
import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import LoadLocalNavigation from "./LoadLocalNavigation";
import LoadBreadCrumb from "./LoadBreadCrumb";
import LoadNavConsultantText from "./LoadNavConsultantText";
import LoadBottomLinks from "./LoadBottomLinks";
import LoadNavSidebarText from "./LoadNavSidebarText";
import { eventQBus } from "../../types/EventQBus";
import LoadSeoMetaBlock from "./LoadSeoMetaBlock";
import { toggles } from "../utils/Toggles";
import { SelectionState } from "@otto-ec/nexus-registry/selection";
import { NexusEventListener, otto } from "@otto-ec/global-resources/nexus";

export default class MultiFiltering {
  private static hasBeenInitialized = false;

  public static init() {
    if (MultiFiltering.hasBeenInitialized) {
      return;
    }
    MultiFiltering.hasBeenInitialized = true;

    /*                                               */
    if (toggles.isActive("REPTILE_1147_NEXUS_SELECTION")) {
      MultiFiltering.onSelectionUpdated(LoadBreadCrumb.onLoadBreadcrumb);
      MultiFiltering.onSelectionUpdated(LoadLocalNavigation.onLoadLocalNavigation);
      MultiFiltering.onSelectionUpdated(LoadNavConsultantText.onLoadNavConsultantText);
      MultiFiltering.onSelectionUpdated(LoadBottomLinks.onLoadBottomLinks);
      MultiFiltering.onSelectionUpdated(LoadNavSidebarText.onLoadNavSidebarText);
      MultiFiltering.onSelectionUpdated(LoadSeoMetaBlock.onLoadSeoMetaBlock);
      return;
    }

    eventQBus.on("ftfind.dresonRule.resolve", FilterResolveDresonRule.resolve);
    MultiFiltering.onResolved(LoadBreadCrumb.onLoadBreadcrumb);
    MultiFiltering.onResolved(LoadLocalNavigation.onLoadLocalNavigation);
    MultiFiltering.onResolved(LoadNavConsultantText.onLoadNavConsultantText);
    MultiFiltering.onResolved(LoadBottomLinks.onLoadBottomLinks);
    MultiFiltering.onResolved(LoadNavSidebarText.onLoadNavSidebarText);
    MultiFiltering.onResolved(LoadSeoMetaBlock.onLoadSeoMetaBlock);
  }

  private static onResolved(callback: (data: DresonRuleResolvedEvent) => void) {
    const onResolved = (data: DresonRuleResolvedEvent) => {
      if ("count" in data && data.count === 0) {
        return;
      }
      callback(data);
    };

    eventQBus.on("ftfind.dresonRule.resolved", onResolved);
  }

  private static onSelectionUpdated(callback: (data: { rule: string }) => void) {
    const listener: NexusEventListener<SelectionState> = (data) => {
      callback(data);
    };
    otto.selection.current.on(listener);
  }
}
